"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRestoredGameId = exports.restoreGameID = exports.normalizeGameID = void 0;
var react_1 = require("react");
var normalizeGameID = function (gameID) {
    return gameID.replace(/\//g, '%2B-');
};
exports.normalizeGameID = normalizeGameID;
var restoreGameID = function (gameID) {
    if (gameID === void 0) { gameID = ''; }
    return gameID.replace(/(%2B-|\+-)/g, '/');
};
exports.restoreGameID = restoreGameID;
var useRestoredGameId = function (gameID) {
    return (0, react_1.useMemo)(function () { return gameID === null || gameID === void 0 ? void 0 : gameID.replace(/%2B-/g, '/'); }, [gameID]);
};
exports.useRestoredGameId = useRestoredGameId;
